export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="font-heading text-xl text-background-50 mb-3">被窝网电影</div>
            <p className="text-sm text-background-400 leading-relaxed">
              电视剧全集免费高清在线观看平台。收录3000+部热门电视剧，覆盖国产剧、韩剧、美剧、日剧、泰剧等全品类资源，每日更新，流畅不缓冲，无需充值尽享全集。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer">热播榜单</a>
              <a href="#comments" className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer">追剧热评</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer">最新动态</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer">常见问题</a>
              <a href="#contact" className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">剧集分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer">国产热播剧</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer">韩剧精选</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer">古装传奇</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer">悬疑探案</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer">美剧英剧</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">合作伙伴</h4>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-background-500">优质内容平台持续加入中</p>
            </div>
            <div className="mt-6">
              <h4 className="font-heading text-sm text-background-50 mb-3">关注我们</h4>
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-wechat-line"></i>
                </span>
                <span className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line"></i>
                </span>
                <span className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2020-2026 被窝网电影 beiwo.tv — 免费电视剧高清在线观看平台
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="hover:text-primary-300 transition-colors cursor-pointer">使用条款</span>
            <span className="hover:text-primary-300 transition-colors cursor-pointer">隐私政策</span>
            <span className="hover:text-primary-300 transition-colors cursor-pointer">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}